module.exports = __webpack_public_path__ + "images/emoji/nut_and_bolt.ad79732c1ed028ccdd43.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/nut_and_bolt.png
// module id = q/+n
// module chunks = 24